import React, {useState} from 'react';

import {makeJsonRestApiRequest} from '~src/httpClient/RestApiService';

export interface GenerativeAiCheckRegistrationState {
  code?: String;
}

interface GaiCheckResponse {
  generativeAiCheckRegistration: GenerativeAiCheckRegistrationState;
}

type RegistrationStateType = {
  checkRegistrationState: GenerativeAiCheckRegistrationState;
  busy: boolean;
  checkRegistration: () => Promise<void>;
  resetRegistrationCheck: () => Promise<void>;
}

export function useGenerativeAICheckRegistrationHook(): RegistrationStateType {

  const [busy, setBusy] = React.useState(false);
  const [checkRegistrationState, setRegistrationState]
    = useState<GenerativeAiCheckRegistrationState>({code: null});

  async function checkRegistration(): Promise<void> {
    setBusy(true);
    makeJsonRestApiRequest<void, GaiCheckResponse>(
      {config: {
          restApiVersion: '3.24',
          httpMethod: 'GET',
          endpoint: `gai/registration/check`,
          serverWideRequest: false
        }, request: null, queryParams: null }
    ).then(
      result => {
        setBusy(false);
        setRegistrationState({code: result.generativeAiCheckRegistration.code});
      },
      (reason: any) => {
        setBusy(false);
        setRegistrationState({code:'1'});
      }
    );
  }

  async function resetRegistrationCheck(): Promise<void> {
    setRegistrationState({code: null});
  }

  return {checkRegistrationState, busy, checkRegistration, resetRegistrationCheck};
}
